/**
 * StoreLink — the bottom-right corner control, and the way into the store.
 *
 * This corner used to hold a book glyph that led to /book. Three drawn marks
 * of an open book at 48px read as decoration, not as somewhere to buy things,
 * and the one place selling anything was reachable only by typing the URL. The
 * word costs the same corner and needs no decoding.
 *
 * Filled rather than outlined. It sits over pages that are almost entirely
 * white or almost entirely black, where a hairline border on a transparent
 * ground all but disappears; a solid pill holds its edge against either, and
 * this is the one control in the corners that should be noticed. Hovering
 * hollows it out, so the hover state is the quiet one.

 *
 * Sized to sit level with the theme toggle opposite it.
 */

import { Link, useLocation } from 'react-router-dom';

const MONO = 'FK Grotesk Mono, monospace';

export function StoreLink() {
  const { pathname } = useLocation();
  const isActive = pathname === '/shop';

  return (
    <div className="fixed bottom-4 right-4 z-[9999]">
      <Link
        to="/shop"
        aria-label="The store — book, zine, prints and posters"
        aria-current={isActive ? 'page' : undefined}
        className="flex items-center h-8 md:h-12 px-5 md:px-6 rounded-full border border-foreground bg-foreground text-background shadow-sm hover:bg-transparent hover:text-foreground transition-colors"
        style={{ fontFamily: MONO, fontSize: '11pt', letterSpacing: '0.06em' }}
      >
        Store
      </Link>
    </div>
  );
}
